<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_his"
      persistent
      max-width="600px"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="pb-0 px-1">
          <v-container style="height: max-content" v-if="inventory">
            <div
              class="d-flex"
              v-for="(history, k) in inventory"
              :key="`${k}-hist`"
            >
              <div class="d-flex flex-column align-center" v-if="history">
                <div
                  class="dot_out"
                  :style="`background: ${
                    history.history.approval == 'approved'
                      ? '#006341'
                      : history.history.approval == 'declined'
                      ? '#FE0404'
                      : history.history.approval == 'revision'
                      ? '#B3A369'
                      : '#001A72'
                  }`"
                ></div>
                <div
                  class="line_graph"
                  :style="`background: ${
                    history.history.approval == 'approved'
                      ? '#006341'
                      : history.history.approval == 'declined'
                      ? '#FE0404'
                      : history.history.approval == 'revision'
                      ? '#B3A369'
                      : '#001A72'
                  }`"
                ></div>
              </div>
              <div class="ml-2" style="flex: 1" v-if="history">
                <v-card outlined class="pa-2 mb-2">
                  <b class="mb-1 bold small_txt">
                    {{
                      $date(history.history.created_at).format(
                        "dddd, DD MMMM YYYY . HH:mm",
                      )
                    }}
                  </b>

                  <div>
                    <a
                      v-if="type == 'review_proposal'"
                      :href="history.link"
                      target="_blank"
                    >
                      <h5 style="width: 100%">
                        {{ history.link }}
                      </h5>
                    </a>
                    <div class="d-flex align-start" v-else>
                      <v-icon class="mr-2">mdi-link</v-icon>
                      <a
                        :href="history.content"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ history.content }}
                      </a>
                    </div>
                    <div class="d-flex align-start mt-2 pb-1">
                      <v-icon small class="mr-2 mt-1"
                        >mdi-progress-clock</v-icon
                      >
                      <v-card flat class="d-flex">
                        <b
                          class="small_txt mb-0 mr-2"
                          :style="`color: ${
                            history.history.approval == 'approved'
                              ? '#006341'
                              : history.history.approval == 'declined'
                              ? '#FE0404'
                              : history.history.approval == 'revision'
                              ? '#B3A369'
                              : '#001A72'
                          }`"
                        >
                          {{ history.history.approval }}
                        </b>
                        <p class="small_txt mb-0" v-if="history.history.notes">
                          : {{ history.history.notes }}
                        </p>
                      </v-card>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
            <div class="pa-3">
              <v-dialog
                v-model="d_up"
                persistent
                max-width="550px"
                scrollable
                @click:outside="d_up = false"
                @keydown.esc="d_up = false"
              >
                <v-card class="rounded_max hide_overflow" flat>
                  <v-toolbar dense flat>
                    <div class="d-flex">
                      <v-icon class="mr-1">mdi-folder</v-icon>
                      <h3>Required Document</h3>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn fab x-small depressed @click="d_up = false"
                      ><v-icon small>mdi-close</v-icon></v-btn
                    >
                  </v-toolbar>
                  <v-card-text class="px-2 pb-0">
                    <v-container style="height: max-content">
                      <div v-if="question">
                        <div
                          v-for="(item, i) in question"
                          :key="i"
                          class="mb-3"
                        >
                          <div>
                            <div class="mb-2">
                              <p class="mb-0" v-html="item.question"></p>
                              <p
                                class="default_txt"
                                v-if="item.attr !== 'checkbox'"
                                v-html="item.additional"
                              ></p>
                            </div>
                            <div
                              class="d-flex align-start"
                              v-if="item.attr == 'text' || item.attr == 'date'"
                            >
                              <v-icon class="mr-1">mdi-chevron-right</v-icon>
                              <p class="mb-0 black--text">
                                <b>{{ item.answer }}</b>
                              </p>
                            </div>
                            <div
                              class="pa-2"
                              v-if="
                                item.id == 13 &&
                                item.attr == 'checkbox' &&
                                item.opt
                              "
                            >
                              <b>Values</b>
                              <v-row
                                no-gutters
                                v-if="item.opt && item.opt.values"
                              >
                                <v-col
                                  cols="4"
                                  v-for="(val, j) in item.opt.values"
                                  :key="`val${j}`"
                                >
                                  <v-checkbox
                                    disabled
                                    color="green"
                                    hide-details
                                    class="mt-2"
                                    v-model="item[`answer`].values"
                                    :label="val"
                                    :value="val"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <div class="mt-2">
                                <b>Competencies</b>
                              </div>
                              <v-row
                                no-gutters
                                v-if="item.opt && item.opt.competencies"
                              >
                                <v-col
                                  cols="4"
                                  v-for="(val, j) in item.opt.competencies"
                                  :key="`com${j}`"
                                >
                                  <v-checkbox
                                    disabled
                                    color="green"
                                    hide-details
                                    class="mt-2"
                                    v-model="item[`answer`].competencies"
                                    :label="val"
                                    :value="val"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </div>
                            <div
                              v-if="item.id == 14 && item.attr == 'checkbox'"
                            >
                              <v-row no-gutters>
                                <v-col
                                  cols="4"
                                  v-for="(val, j) in item.opt"
                                  :key="`14${j}`"
                                >
                                  <v-checkbox
                                    disabled
                                    color="green"
                                    hide-details
                                    class="mt-2"
                                    v-model="item[`answer`]"
                                    :label="val"
                                    :value="val"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                          <v-divider></v-divider>
                        </div>
                      </div>
                    </v-container>
                  </v-card-text>
                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  components: {},
  name: "historySubmission",
  props: ["d_his", "title", "inventory", "question", "type"],
  data() {
    return {
      d_up: false,
    };
  },
  mounted() {
    console.log(this.inventory);
  },
  methods: {
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
    viewReqDoc(answer) {
      this.question.forEach((el) => {
        for (let key in answer) {
          if (el.attr == "checkbox") {
            if (this.isJson(el.additional)) {
              el["opt"] = JSON.parse(el.additional);
            }
          }
          if (el.id == key) {
            el[`answer`] = answer[key];
          }
        }
      });
      console.log(answer);
      this.d_up = true;
    },
    isJson(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.dot_out {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  /* background: green; */
}
.line_graph {
  width: 2px;
  /* background: green; */
  height: 100%;
  margin-top: -5px;
}
</style>
